<h5>{{ 'fence.installations.mixed-installations' | translate }}</h5>

<div class="materials-container">
  @for (installationMixing of installationMixings; track getTrackKey(installationMixing)) {
    <div (click)="selectInstallationMixing(installationMixing)"
         [class.active]="isInstallationMixingSelected(installationMixing)"
         class="materials-card">
      <img [src]="baseImgURL + installationMixing.icon.path" alt="installation-img" class="board-img" />
      <p class="board-title">{{ installationMixing.primaryInstallation.name }} + {{ installationMixing.secondaryInstallation.name }}</p>
    </div>
  } @empty {
    <ng-casto-loader></ng-casto-loader>
  }
</div>

@if (isInstallationMixing) {
  <!-- Nombre de lame + nom de la lame primaire -->
  <h5>{{ 'fence.installations.installation-choice' | translate }}</h5>
  <section class=" installation-mixing-options">
    <div class="form-row">
      <div class="form-label">
        <label for="mixedCount">{{ 'fence.installations.board-count' | translate:{ installation: secondaryInstallation.name.toLowerCase() } }}</label>
      </div>
      <div class="form-input">
        <div class="number">
          <input
            (change)="changeSecondaryInstallationQuantity($event)"
            [ngModel]="secondaryInstallationQuantity"
            [min]="1"
            [max]="maxBoard"
            autocorrect="off"
            id="mixedCount"
            spellcheck="false"
            type="number" />
        </div>
      </div>
    </div>

    <!-- On n'affiche que s'il est possible d'inverser la pose sur ce mixage -->
    @if (installationMixingCanBeReversed) {
      <div class="form-row">
        <div class="form-label">
          <label for="reverse-installations">
            {{ 'fence.installations.reverse-installations' | translate }}
          </label>
        </div>
        <div class="form-switch">
          <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
          <div class="custom-control custom-switch">
            <input
              (change)="changeInstallationMixOrder()"
              [ngModel]="!isInstallationMixAscOrder"
              class="custom-control-input"
              id="reverse-installations"
              type="checkbox" />
            <label class="custom-control-label" for="reverse-installations">{{
                'fence.configuration.yes' | translate
              }}</label>
          </div>
        </div>
      </div>
    }
  </section>
}
